export var PHOTO_ORIENTATIONS = Object.freeze({
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
});